import api from './api';
import { ApiResponse, PaginatedResponse } from '../types';

export interface Service {
  _id: string;
  name: string;
  slug: string;
  status: 'active' | 'inactive';
  isDeleted: boolean;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateServiceData {
  name: string;
  status: 'active' | 'inactive';
}

const serviceService = {
  async getActiveServices(params?: {
    page?: number;
    limit?: number;
    search?: string;
  }): Promise<ApiResponse<PaginatedResponse<Service>>> {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.search) queryParams.append('search', params.search);
    
    const response = await api.get(`/service?${queryParams.toString()}`);
    return response.data;
  },

  async createService(serviceData: CreateServiceData): Promise<ApiResponse<Service>> {
    const response = await api.post('/service', serviceData);
    return response.data;
  }
};

export default serviceService;
